import { Suspense, useEffect } from 'react';
import { HashRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from '../pages/Login';
import CreateAccount from '../pages/CreateAccount';
import ActivateAccount from '../pages/ActivateAccount';
import ClientCredentials from '../pages/ClientCredentials';
import ThankYou from '../pages/ThankYou';
import WathqVerification from '../pages/WathqVerification';
import ChooseAccountType from '../pages/ChooseAccountType';
import ChooseApplicantType from '../pages/ChooseApplicantType';
import LinkedAccounts from '../pages/LinkedAccounts';
import Home from '../pages/Home';
import { getStrapiContent } from '../store/actions/contentAction';
import { useDispatch } from 'react-redux';
import { Wrapper } from '../components';
import { notificationListener } from '../utils/notification_service';
import { showToast } from '../utils/utils';
import images from '../constants/images';
import ForgetPassword from '../pages/ForgetPassword';
import Otp from '../pages/Otp';
import { routes } from '../config/config';
import { CircularProgress } from '@mui/material';
import ResetPassword from '../pages/ResetPassword';
import PendingApplications from '../pages/PendingApplications';
import EligibleAccounts from '../pages/EligibleAccounts';
import ScreenTracker from '../pages/ScreenTracker';

const LoginRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/${search}`} replace />;
};

const Router = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const getContent = async () => {
      dispatch(getStrapiContent());
    };
    getContent();

    // Foreground push messages
    let unsubscribe = () => { };
    notificationListener((payload) => {
      const title = payload?.notification?.title ?? payload?.data?.title;
      const body = payload?.notification?.body ?? payload?.data?.body;
      showToast({
        image: images.logo,
        title,
        props: {
          text: body,
          customClass: {
            popup: 'push_toast',
            title: 'push_toast_title',
            htmlContainer: 'push_toast_text',
            container: 'swap',
          },
        },
      });
    }).then((unsub) => {
      unsubscribe = unsub;
    });

    return () => unsubscribe();
  }, []);

  const withWrapper =
    (Component, isSideBar = true, isPublic = false, isCenter = false) =>
      (props) => (
        <Wrapper isSideBar={isSideBar} isPublic={isPublic} isCenter={isCenter}>
          <Component {...props} />
        </Wrapper>
      );

  const indicatorSize = 80;

  return (
    <HashRouter>
      <div>
        <ScreenTracker />
        <Suspense
          fallback={
            <CircularProgress
              size={indicatorSize}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: `${-indicatorSize / 2}px`,
                marginLeft: `${-indicatorSize / 2}px`,
              }}
            />
          }
        >
          <Routes>
            {/* <Route Component={Home} /> */}
            {/* <Route path={'/welcome'} Component={Welcome} /> */}
            <Route index Component={Login} />
            <Route path={'/login'} Component={LoginRedirect} />
            {/* <Route path={'/joinus'} Component={JoinUs} /> */}
            {/* <Route
              path={"/register-digital-account"}
              Component={RegiaterDigitalChannel}
            /> */}
            {/* <Route path={"/account-setup"} Component={AccountSetup} /> */}
            <Route path={'/forget-password'} Component={ForgetPassword} />
            {/* <Route path={'/recover-username'} Component={RecoverUsername} /> */}
            <Route path={'/otp'} Component={Otp} />
            <Route path={'/reset-password'} Component={ResetPassword} />
            <Route path={'/create-account'} Component={CreateAccount} />
            <Route path={'/active-account'} Component={ActivateAccount} />
            <Route path={'/set-client-credentials'} Component={ClientCredentials} />
            <Route path={'/thank-you'} Component={ThankYou} />
            <Route path={'/wathq-verification'} Component={WathqVerification} />
            <Route path={'/choose-account-type'} Component={ChooseAccountType} />
            <Route path={'/pending-applications'} Component={PendingApplications} />
            {/* <Route path={'/eligible-accounts'} Component={EligibleAccounts} /> */}
            <Route path={'/choose-applicant-type'} Component={ChooseApplicantType} />
            <Route path={'/linked-accounts'} Component={LinkedAccounts} />

            {routes?.map((item, index) => (
              <Route key={index} path={item?.path} Component={withWrapper(item?.component, item?.isSidebar, item?.isPublic, item?.isCenter)} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </HashRouter>
  );
};

export default Router;
